module.exports = __webpack_public_path__ + "media/assets/mike-3733c0baba859658703a79fdabec1b4d.jpg";